module.exports = __webpack_public_path__ + "img/solar_crest.89238391.png";